// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"popUp__wrapper__150vU","backStage":"popUp__backStage__DBdZY","window":"popUp__window__38hVy"};